import { render, staticRenderFns } from "./DemonstracaoResultadoFormulaPerfil.vue?vue&type=template&id=303e0219"
import script from "./DemonstracaoResultadoFormulaPerfil.vue?vue&type=script&lang=js"
export * from "./DemonstracaoResultadoFormulaPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports